module.exports = __webpack_public_path__ + "lp/img/vote_neutral_active.ca069608.svg";